import React from 'react';

import './budget-stocks-in-focus-horizontal-shimmer.m.css';

const BudgetStocksInFocusHorizontalShimmer = () => {
  return (
    <>
      <div styleName="stock-shimmer">
        {Array.apply(null, Array(6)).map((value, index) => (
          <div styleName="stock-ctx" key={index}>
            <div styleName="img-card"></div>
            <div styleName="shimmer-ctx">
              <div styleName="first-row"></div>
              <div styleName="second-row"></div>
              <div styleName="third-row"></div>
            </div>
          </div>
        ))}
      </div>
      <div styleName="shimmer-btn"> </div>
    </>
  );
};

export default BudgetStocksInFocusHorizontalShimmer;
